import type { DashboardStatusCategory } from '@myapp/contract'
import type { DashboardMetric } from '../../../entities/dashboard'

export type DashboardPeriodMode = 'year' | 'months'

/** The dashboard starts on 01.09.2026; there is nothing to show before it. */
export const DASHBOARD_START_MONTH = '2026-09'
export const DASHBOARD_FIRST_YEAR = 2026

export interface DashboardFiltersForm {
  mode: DashboardPeriodMode
  year: number
  /** "YYYY-MM", only used in `months` mode. */
  from: string
  to: string
  /** Gewerk keys (`String(gewerkId)` or "none"). Empty means all. */
  gewerke: string[]
  technicianId: number | null
  status: DashboardStatusCategory | null
  metric: DashboardMetric
}
